export default __webpack_public_path__ + "static/media/cold-drip.cc8f8a62.png";